import { stdObject } from "../data/types/stdObject";

export default function IconIntoDiv({
  Icon,
  onClick,
  style = {},
}: {
  Icon: any;
  onClick: any;
  style?: stdObject;
}) {
  return (
    <div onClick={onClick} className="divIconContainer">
      <Icon className="iconInDiv" style={style} />
    </div>
  );
}
